import { useCheckboxGroup } from '@react-aria/checkbox'
import { PropsWithChildren } from 'react'
import { useCheckboxGroupState } from '@react-stately/checkbox'
import { CheckboxGroupContext } from 'components/CheckboxGroup/CheckboxGroupContext'
import { CheckboxGroupProps } from './Types'
import { LabelContext } from 'components/CheckboxGroup/LabelContext'

export const CheckboxGroup = ({ className, ...props }: PropsWithChildren<CheckboxGroupProps>) => {
  const { children } = props
  const state = useCheckboxGroupState(props)
  const { groupProps, labelProps } = useCheckboxGroup(props, state)

  return (
    <div {...groupProps} className={className}>
      <LabelContext.Provider value={{ labelProps, label: props.label }}>
        <CheckboxGroupContext.Provider value={state}>{children}</CheckboxGroupContext.Provider>
      </LabelContext.Provider>
    </div>
  )
}
